import React, { memo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
	CTX_STATE,
	disCount,
	specialNavigate,
	protypeObj,
	countdown,
} from "../common";
import gameIcon from "./styles/scss/img/long_list/game-icon.png";
import gameNone from "../styles/scss/img/common/game-none.png";

function App(props) {
	const { list = [], search, from } = props;
	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);

	//网吧版兼容
	const isNetbar = window.mbQuery?.appInfo?.type === "netbar";

	return (
		<>
			{list.length ? (
				list.map((ele, index) => {
					const isWjyz = from === "wjyz" ? true : ele.protype ? true : false; //wjyz搜索结果有protype字段
					const list_img = isWjyz
						? `url(https://cdn-wjyz.wanjiayizhan.com${encodeURI(ele.img_url)})`
						: `url(${ele.list_img})`;
					const product_name = isWjyz ? ele.name : ele.product_name;
					const tag = isWjyz
						? [
								{
									name: ele.pro_platform,
								},
								{
									name: ele.pro_area,
								},
								{
									name: ele.pro_version,
								},
						  ]
						: ele.tag;
					const discount = isWjyz
						? disCount(ele.price, ele.special_price)
						: disCount(ele.source_price, ele.group_vip_price);
					const origin_price = isWjyz ? ele.price / 100 : ele.source_price;
					const price = isWjyz ? ele.special_price / 100 : ele.group_vip_price;
					const protypeName = (function () {
						let name = "共享游戏";
						if (isWjyz) {
							for (const key in protypeObj) {
								if (Object.hasOwnProperty.call(protypeObj, key)) {
									const element = protypeObj[key];
									if (element === ele.protype) {
										name = key;
										break;
									}
								}
							}
						}

						return name;
					})();
					const canFreePlay = countdown(ele.created_at) <= 0;

					return (
						<div
							className="list-item"
							key={index}
							onClick={() => {
								specialNavigate("/Goods", _state.token, navigate, isWjyz, ele);
							}}
						>
							<div>
								<div
									style={{
										backgroundImage: list_img,
									}}
								></div>
								<div>
									<div>{product_name}</div>
									<div>
										{(tag || []).map((ele, index) => {
											return <div key={index}>{ele.name}</div>;
										})}
									</div>
									{!isWjyz && (
										<div>
											<img src={gameIcon} alt="game" />
											<span>
												{Math.floor(Math.random() * (4000 + 1)) + 1000}
											</span>
											人在玩
										</div>
									)}
								</div>
							</div>

							<div>
								{search && <div className="protypeName">{protypeName}</div>}
								{!!discount && (
									<>
										<div className="discount">-{discount}%</div>
										<div className="origin-price">￥{origin_price}</div>
									</>
								)}
								<div className="price">
									{!isWjyz && canFreePlay && isNetbar ? "免费" : `￥${price}`}
								</div>
							</div>
						</div>
					);
				})
			) : (
				<div className="none">
					<img src={gameNone} alt="none" />
					<p>当前暂无任何游戏...</p>
				</div>
			)}
		</>
	);
}

export default memo(App);
